<div class="modal-header">
    <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
            <ion-col size="10"
                     class="ion-no-padding">
                {{ block.title | translate}}
            </ion-col>
            <ion-col size="2"
                     class="ion-no-padding ion-text-right">
                <a (click)="close()">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-close.svg"
                              class="icon fill-dark">
                    </svg-icon>
                </a>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>

<ng-container *ngIf="loading">
    <div class="content-centered-column loading">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>


<div *ngIf="!loading && event && (event.translate(userLang)[block.key] || (block.customLabel && block.customLabel.translateOrNew(userLang).external_link))"
     class="content-centered-column">

    <div class="fr-view"
         [innerHTML]="event.translate(userLang)[block.key] | linkify | securedImages | safe:'html'">
    </div>
    <ng-container *ngIf="!event.translate(userLang)[block.key] && block.customLabel && block.customLabel.translateOrNew(userLang).external_link">
        <ng-container *ngIf="!block.customLabel.translateOrNew(userLang).external_link_doc">
            <iframe class="p-w-md"
                    frameBorder="0"
                    width="100%"
                    sandbox="allow-scripts allow-same-origin allow-forms allow-presentation allow-popups"
                    [ngClass]="{'hidden': !block.customLabel.loadedIframe}"
                    (load)="onLoad(block.customLabel)"
                    [src]="block.customLabel.translateOrNew(userLang).external_link | safe:'resourceUrl'">
            </iframe>
        </ng-container>
        <ng-container *ngIf="block.customLabel.translateOrNew(userLang).external_link_doc">
            <iframe class="p-w-md"
                    frameBorder="0"
                    width="100%"
                    [ngClass]="{'hidden': !block.customLabel.loadedIframe}"
                    (load)="onLoad(block.customLabel)"
                    [src]="block.customLabel.translateOrNew(userLang).external_link | safe:'resourceUrl'">
            </iframe>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="event.translate(userLang)[block.key] && block.customLabel && block.customLabel.translateOrNew(userLang).external_link">
        <ion-button class="btn"
                    (click)="showExternalLink(block.customLabel)">{{ 'EXTERNAL_HTML_SHOW_MORE' | translate}}</ion-button>
    </ng-container>

</div>